<template>
  <div class="navbar">
    <Container>
      <ul class="nav" v-if="showLinks">
        <li class="nav__item">
          <router-link :to="localizedLink('home')" class="nav__link">
            <span>{{ $t("implementation") }}</span>
          </router-link>
        </li>
        <li class="nav__item">
          <router-link :to="localizedLink('documentation')" class="nav__link">
            <span>{{ $t("documentation") }}</span>
          </router-link>
        </li>
        <li class="nav__item">
          <router-link :to="localizedLink('datasets')" class="nav__link">
            <span>{{ $t("datasets") }}</span>
          </router-link>
        </li>
      </ul>
    </Container>
  </div>
</template>

<script>
import { localizedLink } from "@/mixins";
import Container from "@/components/homepage/Container";

export default {
  mixins: [localizedLink],
  components: {
    Container
  },
  props: {
    showLinks: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  font-size: rem(14);
  background-color: $--navbar-background;
  @media (max-width: $breakpoint-sm - 1) {
    width: 100%;
    background-color: transparent;
    z-index: 9999;
    position: absolute;
    left: -100%;
    padding-bottom: 100px;
    background-position: right -30px bottom;
    background-repeat: no-repeat;
    background-image: url(../../../assets/images/illustration-main-small.svg);
  }
}

.nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (max-width: $breakpoint-sm - 1) {
    display: block;
  }
}

.nav__item--ml-auto {
  margin-left: auto;
}

.nav__item {
  padding-top: $--nav-item-padding-top;
  padding-bottom: $--nav-item-padding-bottom;

  &:not(:last-child) {
    margin-right: $--nav-item-spacing-y;
  }
}

@media (max-width: $breakpoint-sm - 1) {
  .nav__item--divider::before {
    content: "";
    display: inline-block;
    width: 32px;
    height: 2px;
    margin-top: 10px;
    margin-bottom: 15px;
    background-color: $--color-white;
  }
}

.nav__link {
  position: relative;
  display: block;
  padding-top: $--nav-link-padding-x;
  padding-bottom: $--nav-link-padding-x;
  color: $--nav-link-color;
  text-decoration: none;
  transition: all 0.1s ease-in-out;
  font-weight: 400;
  @media (min-width: $breakpoint-sm) {
    &:not(.nav__link--button)::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: $--nav-link-after;
      height: $--nav-link-height;
      background-color: transparent;
      transition: all 0.1s ease-in-out;
    }

    &:not(.nav__link--button):hover {
      color: $--color-white;
      &::after {
        background-color: $--color-white;
        bottom: $--nav-link-after-hover;
      }
    }

    &:not(.nav__link--button).router-link-exact-active {
      color: $--color-white;
      &::after {
        background-color: $--color-white;
        bottom: $--nav-link-after-hover;
      }
    }
  }
}

.nav__link--button {
  font-weight: 700;

  @media (min-width: $breakpoint-sm) {
    font-weight: 700;
    padding: $--nav-link-button-padding;
    border: 2px solid $--color-white;
    &:hover {
      color: $--color-landing-primary;
      background-color: $--color-white;
    }
  }
}
</style>
